import { render, staticRenderFns } from "./QtySetter.vue?vue&type=template&id=8a89f37e&scoped=true&"
import script from "./QtySetter.vue?vue&type=script&lang=js&"
export * from "./QtySetter.vue?vue&type=script&lang=js&"
import style0 from "./QtySetter.vue?vue&type=style&index=0&id=8a89f37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a89f37e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
